// extracted by mini-css-extract-plugin
module.exports = {"chart":"TrafficChannel_chart__ZgAKy","legend":"TrafficChannel_legend__1tQc6","indicator":"TrafficChannel_indicator__2EVRR","color":"TrafficChannel_color__2cP_B"};